define((require) => {
    "use strict";

    const {defaults}            = require("underscore");
    const ChannelSetupItemView = require("ui/publish/channelSetup/ChannelSetupItemView");
    const template             = require("ui/projects/publish/ProjectChannelSetupItemView.tpl");

    /**
     * Subclass of ChannelSetupItemView representing the item view of the attach lightbox Channel in a project context.<p>
     * @class ProjectAttachChannelSetupItemView
     * @see ChannelSetupItemView
     */
    return ChannelSetupItemView.extend("ProjectAttachChannelSetupItemView", {

        _channelSelected: false,

        template,

        templateHelpers() {
            const parentTemplateHelpers = this.__super(); // ChannelSetupItemView.prototype.templateHelpers.call(this);

            // Extending the parent templateHelpers
            return defaults({
                showChannelActionsPanel: this.options.showChannelActionsPanel
            }, parentTemplateHelpers);
        },

        initialize() {
            this.__super();
            this._itemViewOptions = this.options.itemViewOptions();
        },

        events: {
            "click": function() {
                this._channelSelected = !this._channelSelected;
                this._itemViewOptions.selectHandler(this.model, this._channelSelected);
                this.$el.toggleClass("selected");
            }
        },

        /**
         * Invoked when any assets has been attached to the current project.
         *
         * Refreshes the current collection view to include the newly attached assets.
         */
        onAttachAsset() {
            this.refresh();
        },

        /**
         * Do nothing as when opening the attach lightbox we do not want to check for unpushed changes.
         */
        handleUnPushedChangesOnRender() { },

        onRender() {
            this.__super();

            const projectContext = this._itemViewOptions.projectContext;

            if (projectContext.project.containsChannel(this.model.get("id"))) {
                this.$el.addClass("in-project");
            } else {
                this.$el.removeClass("in-project");
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/publish/ProjectAttachChannelSetupItemView.js